export var StandardBackupScheduleFrequency;
(function (StandardBackupScheduleFrequency) {
    StandardBackupScheduleFrequency["STANDARD_BACKUP_SCHEDULE_INTERVAL"] = "INTERVAL";
    StandardBackupScheduleFrequency["STANDARD_BACKUP_SCHEDULE_DAILY"] = "DAILY";
    StandardBackupScheduleFrequency["STANDARD_BACKUP_SCHEDULE_WEEKLY"] = "WEEKLY";
    StandardBackupScheduleFrequency["STANDARD_BACKUP_SCHEDULE_MONTHLY"] = "MONTHLY";
    StandardBackupScheduleFrequency["STANDARD_BACKUP_SCHEDULE_ANNUALLY"] = "ANNUALLY";
    StandardBackupScheduleFrequency["STANDARD_BACKUP_SCHEDULE_UNSPECIFIED"] = "UNSPECIFIED";
})(StandardBackupScheduleFrequency || (StandardBackupScheduleFrequency = {}));
